module.exports = __webpack_public_path__ + "img/pulse-sms-plus-logo-light-bg.2e5f9a14.png";